const HowToCookLoading = () => {
  return (
    <div
      className="rounded-lg bg-[#FFFAEE] px-3.5 py-5 tex-dark text-sm"
    >
      <div className="animate-pulse flex w-full">
        <div className="flex-1 space-y-6 py-1">
          <div className="space-y-3">
            <div className="grid grid-cols-3 gap-4 place-items-center">
              <div className="h-3 w-full bg-gray-300 rounded col-span-2"></div>
              <div className="h-3 w-full bg-gray-300 rounded col-span-3"></div>
              <div className="h-3 w-full bg-gray-300 rounded col-span-3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HowToCookLoading
